import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MUISelect, { SelectProps } from '@mui/material/Select';
import { forwardRef } from 'react';

export const Select = forwardRef<HTMLInputElement, SelectProps>(
  ({ label, id, children, disabled, ...props }, ref) => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id={`${id}-label`} disabled={disabled}>
          {label}
        </InputLabel>
        <MUISelect
          labelId={`${id}-label`}
          id={id}
          label={label}
          disabled={disabled}
          ref={ref}
          IconComponent={KeyboardArrowDownIcon}
          {...props}
        >
          {children}
        </MUISelect>
      </FormControl>
    );
  },
);

Select.displayName = 'Select';
